/**
 * Breadcrumb - Componente de navegación para la vista de detalle de Pre-Factura
 *
 * Muestra el breadcrumb con la estructura: Facturación > Prefacturas > [Código]
 * El código de la prefactura se muestra dinámicamente según la prefactura actual.
 */
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface BreadcrumbProps {
  /** Código de la prefactura (ej. "PF-8752") */
  preInvoiceCode?: string;
}

export const Breadcrumb = ({ preInvoiceCode }: BreadcrumbProps) => {
  const { t } = useTranslation('viewPreInvoicesModule');

  const breadcrumbs = useMemo(
    () => [
      { label: t('breadcrumb.invoices', 'Facturación') },
      {
        label: t('breadcrumb.preinvoices', 'Prefacturas'),
        path: '/invoices/pre-invoices',
      },
      {
        label: <span className="text-title">{preInvoiceCode || t('breadcrumb.loading', 'Cargando...')}</span>,
        _key: preInvoiceCode ?? 'loading',
      },
    ],
    [t, preInvoiceCode],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
